/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Table_CreditsInputs */

const en_settings_table_credits = /** @type {(inputs: Settings_Table_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits`)
};

const de_settings_table_credits = /** @type {(inputs: Settings_Table_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktionen`)
};

const fr_settings_table_credits = /** @type {(inputs: Settings_Table_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

const es_settings_table_credits = /** @type {(inputs: Settings_Table_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acciones`)
};

const it_settings_table_credits = /** @type {(inputs: Settings_Table_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crediti`)
};

const nl_settings_table_credits = /** @type {(inputs: Settings_Table_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits`)
};

const pl_settings_table_credits = /** @type {(inputs: Settings_Table_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kredyty`)
};

const fi_settings_table_credits = /** @type {(inputs: Settings_Table_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luotot`)
};

const da_settings_table_credits = /** @type {(inputs: Settings_Table_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kreditter`)
};

const sv_settings_table_credits = /** @type {(inputs: Settings_Table_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krediter`)
};

/**
* | output |
* | --- |
* | "Credits" |
*
* @param {Settings_Table_CreditsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_table_credits = /** @type {((inputs?: Settings_Table_CreditsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Table_CreditsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_table_credits(inputs)
	if (locale === "fr") return fr_settings_table_credits(inputs)
	if (locale === "es") return es_settings_table_credits(inputs)
	if (locale === "it") return it_settings_table_credits(inputs)
	if (locale === "nl") return nl_settings_table_credits(inputs)
	if (locale === "pl") return pl_settings_table_credits(inputs)
	if (locale === "fi") return fi_settings_table_credits(inputs)
	if (locale === "da") return da_settings_table_credits(inputs)
	if (locale === "sv") return sv_settings_table_credits(inputs)
	return en_settings_table_credits(inputs)
});